import React, {useMemo} from "react";
import Tr from "translations/Translations";
import PropTypes from "prop-types";
import {FormHelperText, makeStyles} from "@material-ui/core";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import {AuctionItemBidType} from "../../constants/AuctionItemBidType";
import BoldTypography from "components/BoldTypography";
import Typography from "components/Typography";
import TextInput from "components/TextInput";
import INPUT_TYPE from "constants/INPUT_TYPE";
import getObjectValue from "libs/getObjectValue";
import Checkbox from "components/Checkbox";


const useStyle = makeStyles(theme => ({
    checkboxColumn: {
        width: 70
    },
    inputColumn: {
        width: 100
    },
    boundaryColumn: {
        width: 320
    }
}));


const OfferChoiceCreateAuctionTable = (
    {
        demandId,
        items,
        working,
        formikProps

    }) => {

    const classes = useStyle();
    const isCriterion = items === 'criterias'

    const headers = useMemo(() => (isCriterion ? [
        Tr('criterion_name'),
        Tr('auction_biddable'),
        Tr('auction_step'),
        Tr('auction_value_min'),
        Tr('auction_value_max'),
        Tr('auction_boundary_values'),
    ] : [
        Tr('position_name'),
        Tr('auction_step'),
        Tr('auction_value_min'),
        Tr('auction_value_max'),
        Tr('auction_boundary_values'),
    ]), [isCriterion]);

    const tableItems = () => {
        let table = undefined;
        if (isCriterion) {
            table = formikProps.values.positions[0].criterias.map((x, index) => {
                if (formikProps.values.positions[0].bidType !== AuctionItemBidType.RFX_CRITERIUM_VALUE && x.type === 'price')
                    return null;
                const nameError = getObjectValue(`positions.0.criterias.${index}.name`, formikProps.errors, null)
                return ([
                    <>
                        {x.name}
                        {!!nameError && <FormHelperText className={classes.text} error>{nameError}</FormHelperText>}
                    </>,
                    <Checkbox
                        id={`positions.0.criterias.${index}.biddable`}
                        formikProps={formikProps}
                        disabled={x.biddableDisabled}
                    />
                    ,
                    <>
                        {x.type !== 'text' && x.type !== 'list' && x.type !== 'yesNo' && x.biddable &&
                        <TextInput
                            id={`positions.0.criterias.${index}.step`}
                            formikProps={formikProps}
                            type={INPUT_TYPE.NUMBER_19}
                            step="0.01"
                        />
                        }
                    </>,
                    <>
                        {x.type !== 'text' && x.type !== 'list' && x.type !== 'yesNo' && x.biddable &&
                        <TextInput
                            id={`positions.0.criterias.${index}.min`}
                            formikProps={formikProps}
                            type={INPUT_TYPE.NUMBER_19}
                            step="0.01"
                        />
                        }
                    </>,
                    <>
                        {x.type !== 'text' && x.type !== 'list' && x.type !== 'yesNo' && x.biddable &&
                        <TextInput
                            id={`positions.0.criterias.${index}.max`}
                            formikProps={formikProps}
                            type={INPUT_TYPE.NUMBER_19}
                            step="0.01"
                        />
                        }
                    </>,
                    <>
                        {!!x.minOfferValue && <Typography>{Tr('auction_criterion_min_value')}: {x.minOfferValue.toFixed(2).replace(/[.]/, ",")}{x.type === 'price' ? ' PLN' : (!!x.measureUnit ? ` (${x.measureUnit})` : '')}</Typography>}
                        {!!x.maxOfferValue && <Typography>{Tr('auction_criterion_max_value')}: {x.maxOfferValue.toFixed(2).replace(/[.]/, ",")}{x.type === 'price' ? ' PLN' : (!!x.measureUnit ? ` (${x.measureUnit})` : '')}</Typography>}
                        {(x.type === 'text' || x.type === 'list' || x.type === 'yesNo') && <Typography>{Tr(`auction_criterion_type_${x.type}`)}</Typography>}
                    </>
                ])

            });
        } else {
            table = formikProps.values.positions[0].items.map((x, index) => {
                const nameError = getObjectValue(`positions.0.items.${index}.name`, formikProps.errors, null)
                return ([
                    <>
                        {x.name}
                        {!!nameError && <FormHelperText className={classes.text} error>{nameError}</FormHelperText>}
                    </>,
                    <TextInput
                        id={`positions.0.items.${index}.step`}
                        formikProps={formikProps}
                        type={INPUT_TYPE.NUMBER_19}
                        step="0.01"
                    />,
                    <TextInput
                        id={`positions.0.items.${index}.min`}
                        formikProps={formikProps}
                        type={INPUT_TYPE.NUMBER_19}
                        step="0.01"
                    />,
                    <TextInput
                        id={`positions.0.items.${index}.max`}
                        formikProps={formikProps}
                        type={INPUT_TYPE.NUMBER_19}
                        step="0.01"
                    />,
                    <>
                        <Typography>{Tr('auction_criterion_min_price')}: {x.minOfferPrice.toFixed(2).replace(/[.]/, ",")} PLN</Typography>
                        <Typography>{Tr('auction_criterion_max_price')}: {x.maxOfferPrice.toFixed(2).replace(/[.]/, ",")} PLN</Typography>
                    </>
                ])
            });
        }
        return table;
    }

    const shouldShow = isCriterion || formikProps.values.positions[0].bidType === AuctionItemBidType.RFX_ITEM_VALUE
        || formikProps.values.positions[0].bidType === AuctionItemBidType.RFX_CRITERIUM_PRICE;

    return (shouldShow && <>
        <BoldTypography>{Tr(isCriterion ? 'auction_criterias_table_title' : 'auction_items_table_title')}</BoldTypography>
        <SimpleTable
            headers={headers}
            items={tableItems()}
            columnClasses={isCriterion ? [
                undefined,
                classes.checkboxColumn,
                classes.inputColumn,
                classes.inputColumn,
                classes.inputColumn,
                classes.boundaryColumn
            ] : [
                undefined,
                classes.inputColumn,
                classes.inputColumn,
                classes.inputColumn,
                classes.boundaryColumn
            ]}
            cellClassName={classes.cell}
        />
    </>)
}

OfferChoiceCreateAuctionTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    items: PropTypes.oneOf(['criterias', 'items']),
    working: PropTypes.bool.isRequired,
    formikProps: PropTypes.object.isRequired,
}

export default OfferChoiceCreateAuctionTable;